import { useTheme } from '@mui/material';

export type BorderRadius = string;

export default (hasRadius: boolean): BorderRadius => {
  const { border } = useTheme();

  return hasRadius ? border.section : 'none';
};
